/**
 * ============================================================================
 * [P3-04-D] SortableURLCard - 정렬 가능한 URL 카드 래퍼
 *
 * 기능:
 * - useSortable 훅으로 드래그 앤 드롭 기능 제공
 * - URLCard를 래핑하여 정렬 기능 추가
 * ============================================================================
 */

// ============================================================================
// 1. Imports
// ============================================================================
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { URLCard } from './URLCard'
import type { URLLink } from '@/types'

// ============================================================================
// 2. Types
// ============================================================================
interface SortableURLCardProps {
  url: URLLink
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}

// ============================================================================
// 3. SortableURLCard Component
// ============================================================================
export function SortableURLCard({ url, onEdit, onDelete }: SortableURLCardProps) {
  // ========================================================================
  // 3-1. useSortable 훅
  // ========================================================================
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: url.id })

  // ========================================================================
  // 3-2. 드래그 중 스타일
  // ========================================================================
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
  }

  // ========================================================================
  // 3-3. Render
  // ========================================================================
  return (
    <div ref={setNodeRef} style={style as React.CSSProperties}>
      <URLCard
        url={url}
        onEdit={onEdit}
        onDelete={onDelete}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  )
}

export default SortableURLCard
